import { CategoryDto } from "../category/category.dto";
import { IdMap } from "../../../core/interfaces/id-map.interface";

export class AccessGroupDto extends CategoryDto {
    memberships: Array<string>;

    mapIds(idMap: IdMap): void {
        super.mapIds(idMap);
        this.memberships = this.mapRefListIds(this.memberships, idMap);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/access-group/access-group.dto.ts